import Project from '../../../components/Project/Project'
import ArtWorkItem from '../../../components/ArtWorkItem/ArtWorkItem'
import Layout from '../../../layout/Layout'
import { integrated } from '../../../resources/artWork'

const Home = () => {
  const { images } = integrated
  return (
    <Layout>
      <div className='Projects'>
        <Project pr={2} {...integrated}>
          {images.map(item => <ArtWorkItem {...item} />)}
        </Project>
      </div>
    </Layout>
  )
}

export default Home